/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseFileSearchCallInProgressEvent = {
  type: "response.file_search_call.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseFileSearchCallInProgressEvent$inboundSchema: z.ZodType<
  ResponseFileSearchCallInProgressEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.file_search_call.in_progress"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseFileSearchCallInProgressEvent$Outbound = {
  type: "response.file_search_call.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseFileSearchCallInProgressEvent$outboundSchema: z.ZodType<
  ResponseFileSearchCallInProgressEvent$Outbound,
  z.ZodTypeDef,
  ResponseFileSearchCallInProgressEvent
> = z.object({
  type: z.literal("response.file_search_call.in_progress"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseFileSearchCallInProgressEventToJSON(
  responseFileSearchCallInProgressEvent: ResponseFileSearchCallInProgressEvent,
): string {
  return JSON.stringify(
    ResponseFileSearchCallInProgressEvent$outboundSchema.parse(
      responseFileSearchCallInProgressEvent,
    ),
  );
}
export function responseFileSearchCallInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseFileSearchCallInProgressEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseFileSearchCallInProgressEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseFileSearchCallInProgressEvent' from JSON`,
  );
}
